import { w2MasterEditPath } from '@/common/app/path'
import { W2MasterData, W2User, W2_MASTER_CONFIGS } from '@/common/model/master/w2Master'

import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  item: W2MasterData
  selected: boolean
  onSelect(): void
  isScrolled: boolean
}

const MasterListRow = ({ item, selected, onSelect, isScrolled }: Props) => {
  return (
    <TableRow>
      {/* <ClickableTableRow href={w2MasterEditPath(item.site_id, item.master_type, item.id)}> */}
      <TableRowItem checkbox sticky={0} width={40} scrollShadow={isScrolled}>
        <CheckBox name={'productId'} checked={selected} onChange={() => onSelect()} />
      </TableRowItem>
      {W2_MASTER_CONFIGS[item.master_type].columns.map((column, index) => (
        <TableRowItem key={column.key}>
          <Text size={14}>
            {(item.data as unknown as Record<string, unknown>)[column.key] as string}
          </Text>
        </TableRowItem>
      ))}
    </TableRow>
  )
}

export default MasterListRow
